import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-stack py-4" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "me-6" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-success fs-2" })
], -1)
const _hoisted_4 = { class: "mb-0 me-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-800 fw-bolder" }, "Request Accepted ", -1)
const _hoisted_6 = { class: "text-gray-900 fs-7" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "#956aff",
    cx: "50%",
    cy: "50%",
    r: "4"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode("You are now a member of "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.entityName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.relativeCreationDate), 1)
      ])
    ]),
    (!_ctx.notification.read)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: "Mark as read",
          placement: "left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.markRead && _ctx.markRead(...args))),
              class: "ml-auto notify-badge"
            }, _hoisted_9)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}